import { render, staticRenderFns } from "./OsdDelete.vue?vue&type=template&id=473ec46f&lang=pug&"
import script from "./OsdDelete.vue?vue&type=script&lang=ts&"
export * from "./OsdDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OsdDelete.vue"
export default component.exports